import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button } from '@ctct/ui-react';

import { useInboxPreviewContext } from './InboxPreviewContext';

const homePage = '/pages/dashboard/home';

const getIbpResultsUrl = (campaignActivityId) => {
  const urlParams = new URLSearchParams(window.location.search);
  const redirectParams = urlParams.get('debug') ? `?debug=${urlParams.get('debug')}` : '';

  return `/pages/campaigns/inboxpreview/results/${campaignActivityId}/embedded${redirectParams}`;
};

const MessageWithHomeButton = ({ children, showButton = true }) => {
  const { t } = useTranslation();

  const [state] = useInboxPreviewContext();
  const { campaignActivityId, embedded } = state;
  const showCtaRun = !!campaignActivityId && embedded;

  return (
    <>
      <div style={{ paddingBottom: 20 }}>{children}</div>
      {showButton &&
        (showCtaRun ? (
          <Button
            shape="square"
            kind="primary"
            onClick={() => {
              window.location.href = getIbpResultsUrl(campaignActivityId);
            }}
            text={t('add-inbox-preview.cta-run')}
            data-qe-id="inbox-preview-cta-run"
          />
        ) : (
          <Button
            shape="square"
            kind="primary"
            onClick={() => {
              window.location.href = homePage;
            }}
            text={t('add-inbox-preview.home')}
            data-qe-id="inbox-preview-error-home"
          />
        ))}
    </>
  );
};

MessageWithHomeButton.propTypes = { children: PropTypes.node.isRequired };

export default MessageWithHomeButton;
